var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"d-flex flex-column align-center justify-center",attrs:{"height":"100%","width":"100%"}},[_c('p',{staticClass:"font-weight-bold primary--text"},[_vm._v("Sorry, this page was not found")]),_c('a',{staticClass:"mt-8 font-weight-bold primary--text",attrs:{"href":"/"}},[_vm._v("HOME")])])
}
var staticRenderFns = []

export { render, staticRenderFns }